document.addEventListener('DOMContentLoaded', function () {
  const bar = document.querySelector('.announcement-bar-slider');
  if (!bar) return;

  const messages = bar.querySelectorAll('.announcement-bar__message');
  if (!messages.length) return;

  // Use innerHTML instead of innerText to preserve any links
  const texts = Array.from(messages).map(m => {
    const content = m.innerHTML.trim();
    const parentLink = m.closest('a');
    if (parentLink && parentLink.href) {
      return `<a href="${parentLink.href}" class="lm-ticker-link">${content}</a>`;
    }
    return content;
  });

  const itemsHTML = texts.map(t =>
    `<span class="lm-ticker-item">${t}</span><span class="lm-ticker-sep">✦</span>`
  ).join('');

  bar.innerHTML = `
    <div class="lm-ticker-wrap">
      <div class="lm-ticker-track">
        ${itemsHTML}${itemsHTML}${itemsHTML}${itemsHTML}
      </div>
    </div>
  `;

  const track = bar.querySelector('.lm-ticker-track');
  if (!track) return;

  requestAnimationFrame(function () {
    const oneSetWidth = track.scrollWidth / 4;

    const style = document.createElement('style');
    style.textContent = `
      @keyframes lm-scroll-measured {
        0%   { transform: translateX(0); }
        100% { transform: translateX(-${oneSetWidth}px); }
      }
      .lm-ticker-track {
        animation: lm-scroll-measured 22s linear infinite !important;
      }
    `;
    document.head.appendChild(style);
  });
});